export default __webpack_public_path__ + "static/red_informatica_salud-ff0cd6e1fb42f7c86e8c485e47ffc536.webp";